var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#BF1616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6403 13.1097C13.6751 13.1446 13.7028 13.1859 13.7216 13.2314C13.7405 13.277 13.7502 13.3258 13.7502 13.375C13.7502 13.4243 13.7405 13.4731 13.7216 13.5186C13.7028 13.5641 13.6751 13.6055 13.6403 13.6403C13.6054 13.6752 13.5641 13.7028 13.5186 13.7217C13.473 13.7405 13.4242 13.7502 13.375 13.7502C13.3257 13.7502 13.2769 13.7405 13.2314 13.7217C13.1859 13.7028 13.1445 13.6752 13.1097 13.6403L9.99996 10.5302L6.89028 13.6403C6.81991 13.7107 6.72448 13.7502 6.62496 13.7502C6.52545 13.7502 6.43002 13.7107 6.35965 13.6403C6.28929 13.57 6.24976 13.4745 6.24976 13.375C6.24976 13.2755 6.28929 13.1801 6.35965 13.1097L9.46981 10L6.35965 6.89034C6.28929 6.81997 6.24976 6.72454 6.24976 6.62503C6.24976 6.52551 6.28929 6.43008 6.35965 6.35971C6.43002 6.28935 6.52545 6.24982 6.62496 6.24982C6.72448 6.24982 6.81991 6.28935 6.89028 6.35971L9.99996 9.46987L13.1097 6.35971C13.18 6.28935 13.2755 6.24982 13.375 6.24982C13.4745 6.24982 13.5699 6.28935 13.6403 6.35971C13.7106 6.43008 13.7502 6.52551 13.7502 6.62503C13.7502 6.72454 13.7106 6.81997 13.6403 6.89034L10.5301 10L13.6403 13.1097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejected-icon.8909addd0b8ca8413c97bb200e857dab.svg";
export { ForwardRef as ReactComponent };